"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceChecker = void 0;
const devicesMeasures_1 = require("../device/devicesMeasures");
const viewport_1 = require("../viewport/viewport");
const types_1 = require("./types");
class DeviceChecker {
    constructor(deviceMeasure = devicesMeasures_1.DEVICE_MEASURE) {
        this.getCurrentDeviceByWidth = () => {
            const currentElementWidth = (0, viewport_1.getElementWidth)() || (0, viewport_1.getElementWidth)(document);
            if (this.isMobile(currentElementWidth)) {
                return types_1.Device.MOBILE;
            }
            if (this.isTablet(currentElementWidth)) {
                return types_1.Device.TABLET;
            }
            if (this.isDesktop(currentElementWidth)) {
                return types_1.Device.DESKTOP;
            }
            return types_1.Device.DESKTOP;
        };
        this.getCurrentDeviceByUserAgent = () => {
            if (navigator.userAgent.includes('mobi')) {
                return types_1.Device.MOBILE;
            }
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent)) {
                return types_1.Device.TABLET;
            }
            return types_1.Device.DESKTOP;
        };
        this.deviceMeasure = deviceMeasure;
    }
    isMobile(viewportWidth) {
        return viewportWidth <= this.deviceMeasure.mobile.width.max;
    }
    isTablet(viewportWidth) {
        return viewportWidth >= this.deviceMeasure.tablet.width.min && viewportWidth <= this.deviceMeasure.tablet.width.max;
    }
    isDesktop(viewportWidth) {
        return viewportWidth >= this.deviceMeasure.desktop.width.min;
    }
}
exports.DeviceChecker = DeviceChecker;
//# sourceMappingURL=DeviceChecker.js.map